import { z } from "zod";

export const workHoursSchema = z
  .object({
    start: z.number().optional(),
    end: z.number().optional(),
    timezone: z.string().optional(),
  })
  .partial();

export type WorkHours = z.infer<typeof workHoursSchema>;

export const cbhSpecialistProfileSchema = z
  .object({
    name: z.string(),
    email: z.string(),
    phone: z.string(),
    workHours: workHoursSchema,
  })
  .partial();

export type CBHSpecialistProfile = z.infer<typeof cbhSpecialistProfileSchema>;

export const accountManagerResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal("workplace"),
    attributes: z.object({
      email: z.string(),
    }),
    relationships: z.object({
      accountManager: z.object({
        data: z.object({
          id: z.string(),
          type: z.literal("employee"),
        }),
      }),
    }),
  }),
  included: z.array(
    z.object({
      id: z.string(),
      type: z.literal("employee"),
      attributes: cbhSpecialistProfileSchema,
    })
  ),
});

export type AccountManagerResponse = z.infer<typeof accountManagerResponseSchema>;

export const billingSpecialistResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal("BillingSpecialist"),
    attributes: cbhSpecialistProfileSchema,
  }),
});

export type BillingSpecialistResponse = z.infer<typeof billingSpecialistResponseSchema>;
